module.exports = __webpack_public_path__ + "media/images/icons/logout-76dcb285d349fd0173c83e6bd6367ae7.png";